import * as yup from 'yup'
import { ContainerDamageLocationFormProfile } from './container-damage-location-form.profile'

export const schema: yup.ObjectSchema<ContainerDamageLocationFormProfile> = yup.object().shape({
  id: yup.number().optional(),
  name: yup.string().label('Name').required(),
  code: yup.string().label('Code').nullable().optional(),
  isDefault: yup.boolean().optional(),
})
